<template>
  <div class="order-account" v-show="!loading">
    <OrderAccountEdit
      v-if="mode === 'edit' || showOrderAccountEdit"
      :orderId="orderId"
      :orderAccountDetail="orderAccountDetail"
      @saveSuccess="handleSaveSuccess"
      @saveFailed="handleSaveFailed"
      @submitSuccess="handleSubmitSuccess"
      @submitFaild="handleSubmitFailed"
      @cancel="handleCancel"
    />
    <OrderAccountView
      v-else-if="mode === 'view' || !showOrderAccountEdit"
      :orderId="orderId"
      :orderAccountDetail="orderAccountDetail"
      :loading="loading"
      @cancel="handleCancel"
    />
  </div>
</template>
<script>
import OrderAccountEdit from './Edit/index.vue'
import OrderAccountView from './View/index.vue'
import { getOrderAccountState } from '@/api/domain/orders'
import { getRentOrderDetail } from '@/api/domain/underLease'

const REQUEST_TIMEOUT = 15000

function withRequestTimeout(promise, timeout = REQUEST_TIMEOUT) {
  let timer
  const timeoutPromise = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error('request timeout')), timeout)
  })
  return Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timer)
  })
}

export default {
  components: {
    OrderAccountEdit,
    OrderAccountView,
  },
  props: {
    // 模式
    // 'edit': 编辑模式
    // 'view': 查看模式
    mode: {
      type: String,
    },
    orderId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      orderDetail: {}, // 订单详情
      orderAccountDetail: {}, // 核算信息
      loading: true,
    }
  },
  computed: {
    // 订单核算编辑态条件: 订单状态为待核算(4500)，且核算信息为空(核算未保存过)，或者如果存在核算信息，那么核算状态必须是待核算(0)或核算失败(4)
    showOrderAccountEdit() {
      return (
        this.orderDetail &&
        [4500].includes(this.orderDetail.state) &&
        (!this.orderAccountDetail ||
          (this.orderAccountDetail &&
            [0, 4, 5].includes(this.orderAccountDetail.state)))
      )
    },
  },
  methods: {
    // 获取订单详情
    async getOrderDetail() {
      let res

      try {
        res = await withRequestTimeout(getRentOrderDetail({
          orderId: this.orderId,
        }))
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.orderDetail = data
      }
    },
    // 获取退车核算信息
    async getOrderAccountState() {
      let res

      try {
        res = await withRequestTimeout(getOrderAccountState({
          orderId: this.orderId,
        }))
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res
      if (code === 1 && data?.state === 5) {
        this.$message.success('司机线上支付的资金正在原路退还中，请稍后刷新页面进行核算')
      }
      if (code === 1 && data?.state === 4) {
        this.messageInstace = this.$message({
          showClose: true,
          message: data?.remarks || '',
          type: 'warning',
          center: true,
          duration: 0,
        })
      }
      if (code === 1) {
        this.orderAccountDetail = data
      }
    },
    handleSaveSuccess() {
      this.$emit('orderAccountSaveSuccess')
    },
    handleSaveFailed() {
      this.$emit('orderAccountSaveFailed')
    },
    handleSubmitSuccess(param) {
      this.$emit('orderAccountSubmitSuccess', param)
    },
    handleSubmitFailed() {
      this.$emit('orderAccountSubmitFailed', null)
    },
    handleCancel() {
      this.$emit('orderAccountCancel')
    },
  },
  deactivated() {
    if (this.messageInstace) {
      this.messageInstace.close()
    }
  },
  created() {
    if (typeof this.mode === 'undefined') {
      Promise.all([this.getOrderDetail(), this.getOrderAccountState()]).finally(
        () => {
          this.loading = false
        },
      )
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-message.is-closable .el-message__content{
  text-align: center !important;
  padding-right: 0px !important;
}
</style>
